export const SET_GLOBALPAY_IFRAME_RESPONSE = 'SET_GLOBALPAY_IFRAME_RESPONSE';
